import { FormControlLabel, RadioGroup, Radio, FormControl, FormLabel } from "@mui/material"
import useAppStore from "store/app"
import { MAX_SYMPTOMS } from "config/constants"
import useTranslation from "hooks/use_translation"

const BinaryQuestion = () => {
  const { currentQuestion, symptomsData } = useAppStore((state) => state.anamnesis)
  const updateSymptomsData = useAppStore((state) => state.updateSymptomsData)
  const { fields } = useTranslation()

  const selectedValue =
    Object.keys(symptomsData).length > 0 ? symptomsData : { [currentQuestion.symptom_id]: null }

  const handleChange = (event) => {
    const { name, value } = event.target

    const newSelectedValue = {
      ...selectedValue,
      [name]: value,
    }

    updateSymptomsData(newSelectedValue)
  }

  return (
    <FormControl fullWidth component="fieldset" sx={{ mb: 4 }}>
      <RadioGroup
        row
        aria-label={currentQuestion.symptom_id}
        name={currentQuestion.symptom_id}
        value={selectedValue[currentQuestion.symptom_id]}
        onChange={handleChange}
      >
        <FormControlLabel value="true" control={<Radio />} label={fields?.yes} />
        <FormControlLabel value="false" control={<Radio />} label={fields?.no} />
        <FormControlLabel value="no_sure" control={<Radio />} label={fields?.no_shure} />
      </RadioGroup>
    </FormControl>
  )
}

export default BinaryQuestion
